import React, { useEffect, useState } from 'react';
import { Col, Row } from 'reactstrap';
import PropTypes from 'prop-types';
import { insert, update, getRegs, notifyByEmail, getProdutoFinal, getProdCoordenadorPfId } from '../../../utils/fc/index.js'
import qs from 'qs';
import moment from 'moment';

import { Button as Btn, Spinner } from 'reactstrap'
import { Box, Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, FormControl, Input, InputLabel, MenuItem, Rating, Select, TextField, TextareaAutosize, Typography } from '@mui/material';

import { useParams } from 'react-router-dom';
//import OneDriveTeste from '../OneDriveTeste/OneDriveTeste';
import handleGeneratePdf from '../../../services/handlePdf.js';
import oikosApi from '../../../services/oikos/index.js'
import { notifyError, notifySuccess } from '../../../utils/notify/index.js'


const ModalFormRevInterna = ( {dataPrevista, tecResp, ...props} ) => {

    const [open, setOpen] = useState(false);
    const [obsTec, setObsTec] = useState('');
    const [valueConteudo, setValueConteudo] = useState(2);
    const [valueGramatica, setValueGramatica] = useState(2);
    const [valueLayout, setValueLayout] = useState(2);
    const [atendimentoTR, setAtendimentoTR] = useState(true);
    const [obsNum, setObsNum] = useState(1);
    const [todos, setTodos] = useState([]);
    const [isStatusLoading, setIsStatusLoading] = useState(false);
    const { prod_id, proj_id } = useParams();
    const [openModalErro, setOpenModalErro] = useState(false);

    const handleClickOpen = () => {
    setOpen(true);
    };

    const handleClose = () => {
    setOpen(false);
    };

    const handleAddTodo = () => {
        setTodos([...todos, { obsNum: todos.length + 1, observacao: '', pagina: '' }]);
    };

    const handleTodoChange = (index, field, value) => {
        const updatedTodos = todos.map((todo, i) =>
            i === index ? { ...todo, [field]: value } : todo
        );
        setTodos(updatedTodos);
    };

    const handleDeleteTodo = (index) => {
        // Filter out the item to be deleted
        const updatedTodos = todos.filter((_, i) => i !== index);

        // Re-enumerate the obsNum values
        const reEnumeratedTodos = updatedTodos.map((todo, i) => ({
            ...todo,
            obsNum: i + 1, // Reassign obsNum based on the new index
        }));

        // Update the state with the re-enumerated list
        setTodos(reEnumeratedTodos);
    };

    const handleChangeObs = (event) => {
        setObsTec(event.target.value);
    };

    const getStatusFour = async () => {
        try {
            const queryString = qs.stringify({
                action: 'get',
                table: 'prodStatusAlt',
                data: {
                    prod_id: props.produto.prod_id,
                    prodStatusTp_id: 4,
                    prodStatusAlt_ativo: 1,
                },
            });

            // Make the GET request
            const res = await oikosApi.get(`/?${queryString}`);

            if (res.ok) {
                const records = res.data;

                if (records.length > 0) {
                    // Find the maximum date
                    const maxDateRecord = records.reduce((maxRecord, currentRecord) => {
                        const currentRecordDate = new Date(currentRecord.prodStatusAlt_dtCria);
                        const maxRecordDate = new Date(maxRecord.prodStatusAlt_dtCria);
                        return currentRecordDate > maxRecordDate ? currentRecord : maxRecord;
                    });

                    console.log('Record with the latest date:', maxDateRecord);
                    return maxDateRecord;
                } else {
                    console.log('No records found.');
                }
            } else {
                console.error('Error in API response:', res.problem, res.data);
            }
        } catch (error) {
            console.error('Unexpected error:', error);
        }
    }

    const getStatusNine = async () => {
        try {
            const queryString = qs.stringify({
                action: 'get',
                table: 'prodStatusAlt',
                data: {
                    prod_id: props.produto.prod_id,
                    prodStatusTp_id: 9,
                    prodStatusAlt_ativo: 1,
                },
            });

            // Make the GET request
            const res = await oikosApi.get(`/?${queryString}`);

            if (res.ok) {
                const records = res.data;

                if (records.length > 0) {
                    // Find the maximum date
                    const maxDateRecord = records.reduce((maxRecord, currentRecord) => {
                        const currentRecordDate = new Date(currentRecord.prodStatusAlt_dtCria);
                        const maxRecordDate = new Date(maxRecord.prodStatusAlt_dtCria);
                        return currentRecordDate > maxRecordDate ? currentRecord : maxRecord;
                    });

                    console.log('Record with the latest date:', maxDateRecord);
                    return maxDateRecord;
                } else {
                    console.log('No records found.');
                }
            } else {
                console.error('Error in API response:', res.problem, res.data);
            }
        } catch (error) {
            console.error('Unexpected error:', error);
        }
    }

    const aprovaCompliance = async () => {
        setIsStatusLoading(true)

        const parecerRevisao = JSON.stringify(todos);
        await insert('prodStatusAlt', {prod_id: props.produto.prod_id, prodStatusTp_id: 4, pf_id: getProdCoordenadorPfId(props.produto), prodStatusAlt_obs: parecerRevisao, prodStatusAlt_data: moment().format('YYYY-MM-DD'), prodStatusAlt_usuarioCria: props.userOikosId, prodStatusAlt_usuarioMod: props.userOikosId});
        const lastStatusFour = await getStatusFour();
        if (atendimentoTR) {
          await insert('prodComplianceAval', {prodStatusAlt_id: lastStatusFour.prodStatusAlt_id, prodComplianceAval_conteudo: valueConteudo, prodComplianceAval_gramat: valueGramatica, prodComplianceAval_layout: valueLayout, prodComplianceAval_aprov: 0, prodComplianceAval_coment: parecerRevisao, prodComplianceAval_atendTR: 1, prodComplianceAval_usuarioCria: props.userOikosId, prodComplianceAval_usuarioMod: props.userOikosId});
          notifySuccess('Produto aprovado!');
        } else {
          await insert('prodComplianceAval', {prodStatusAlt_id: lastStatusFour.prodStatusAlt_id, prodComplianceAval_conteudo: valueConteudo, prodComplianceAval_gramat: valueGramatica, prodComplianceAval_layout: valueLayout, prodComplianceAval_aprov: 0, prodComplianceAval_coment: parecerRevisao, prodComplianceAval_atendTR: 0, prodComplianceAval_usuarioCria: props.userOikosId, prodComplianceAval_usuarioMod: props.userOikosId});
          notifySuccess('Produto aprovado!');
        }
        await notifyByEmail(props.produto.prod_id, {obs: parecerRevisao});
        setIsStatusLoading(false);
        handleClose();
        props.setCount(prevState => prevState + 1);
    }

    const reprovaCompliance = async () => {
        setIsStatusLoading(true)

        const parecerRevisao = JSON.stringify(todos);
        await insert('prodStatusAlt', {prod_id: props.produto.prod_id, prodStatusTp_id: 9, pf_id: getProdCoordenadorPfId(props.produto), prodStatusAlt_obs: obsTec, prodStatusAlt_data: moment().format('YYYY-MM-DD'), prodStatusAlt_usuarioCria: props.userOikosId, prodStatusAlt_usuarioMod: props.userOikosId});
        await update('prod', props.produto.prod_id, {prod_aprovCompliance: 1})
        const lastStatusNine = await getStatusNine();
        if (atendimentoTR) {
          await insert('prodComplianceAval', {prodStatusAlt_id: lastStatusNine.prodStatusAlt_id, prodComplianceAval_conteudo: valueConteudo, prodComplianceAval_gramat: valueGramatica, prodComplianceAval_layout: valueLayout, prodComplianceAval_aprov: 1, prodComplianceAval_coment: obsTec, prodComplianceAval_atendTR: 1, prodComplianceAval_usuarioCria: props.userOikosId, prodComplianceAval_usuarioMod: props.userOikosId});
        } else {
          await insert('prodComplianceAval', {prodStatusAlt_id: lastStatusNine.prodStatusAlt_id, prodComplianceAval_conteudo: valueConteudo, prodComplianceAval_gramat: valueGramatica, prodComplianceAval_layout: valueLayout, prodComplianceAval_aprov: 1, prodComplianceAval_coment: obsTec, prodComplianceAval_atendTR: 0, prodComplianceAval_usuarioCria: props.userOikosId, prodComplianceAval_usuarioMod: props.userOikosId});
        }
        await notifyByEmail(props.produto.prod_id, {obs: parecerRevisao});
        notifySuccess('Produto reprovado!');
        setIsStatusLoading(false);
        handleClose();
        props.setCount(prevState => prevState + 1);
    };

    return (
        <>
            <Button variant="" onClick={handleClickOpen}>
                Revisar
            </Button>
            <Dialog
                fullWidth
                maxWidth= 'sm'
                open={open}
                onClose={handleClose}
                PaperProps={{
                    component: 'form',
                    onSubmit: async (event) => {
                        event.preventDefault();
                        const formData = new FormData(event.currentTarget);
                        const formJson = Object.fromEntries(formData.entries());
                        console.log(formJson);
                        console.log('Entregue a Gestão')
                        handleClose();
                    },
                    }}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
            <DialogTitle>Revisão Interna</DialogTitle>
            <DialogContent>
                <div className="d-flex">
                    <div className='d-flex flex-column flex-fill'>
                        <div className="d-flex justify-content-between mb-3">
                            <div>
                                <span>Técnico Responsável</span>
                                <h6>{tecResp}</h6>
                            </div>
                            <div>
                                <span>Prazo de entrega</span>
                                {(new Date(dataPrevista).getTime() > Date.now()) ? <h6 className='text-success'>{dataPrevista}</h6> : <h6 className='text-danger'>{dataPrevista}</h6>}
                            </div>
                        </div>
                        <div className="d-flex justify-content-between mb-3">
                            <div>
                                <span>Observações do(a) técnico(a):</span>
                                <h6>{props.prodStatusAlt_obs}</h6>
                            </div>
                        </div>
                        {/*
                        <span>Observação:</span>
                        <TextareaAutosize
                            placeholder='Observações'
                            margin="dense"
                            id="input_obs"
                            name="input_obs"
                            variant="standard"
                            className='mb-3 p-1'
                            onChange={handleChangeObs}
                        />
                        */}

                        <div className="d-flex justify-content-between mb-3">
                            <div>
                                <Typography className='mt-4' component="legend">Gramática</Typography>
                                <Rating
                                    name="avaliacao_gramatica"
                                    value={valueGramatica}
                                    onChange={(event, newValue) => {
                                        setValueGramatica(newValue);
                                    }}
                                />
                            </div>
                            <div>
                                <Typography className='mt-4' component="legend">Conteúdo</Typography>
                                <Rating
                                    name="avaliacao_conteudo"
                                    value={valueConteudo}
                                    onChange={(event, newValue) => {
                                    setValueConteudo(newValue);
                                    }}
                                />
                            </div>
                            <div>
                                <Typography className='mt-4' component="legend">Layout e formatação</Typography>
                                <Rating
                                    name="avaliacao_layout"
                                    value={valueLayout}
                                    onChange={(event, newValue) => {
                                    setValueLayout(newValue);
                                    }}
                                />
                            </div>
                        </div>
                        <div>
                            <Typography className='mt-4 mb-1' component="legend">Atendimento ao TR</Typography>
                            <div className='d-flex align-items-center'>
                                <input
                                    style={{width: "16px", height: "16px"}}
                                    type="checkbox"
                                    name="atendimentoTR"
                                    id="atendimentoTR"
                                    onChange={(event) => {
                                        setAtendimentoTR(event.target.checked)
                                    }}
                                    checked={atendimentoTR}
                                />
                                {atendimentoTR && (
                                    <span className='text-success ml-2'>Está atendendo ao TR</span>
                                )}
                                {!atendimentoTR && (
                                    <span className='text-danger ml-2'>Não está atendendo ao TR</span>
                                )}
                            </div>
                        </div>
                        <div className='d-flex align-items-center mt-4'>
                            <span className='mr-2' style={{cursor: 'pointer'}} onClick={handleAddTodo}>Adicionar parecer</span>
                            <Btn
                                title="Adicionar Observação"
                                className="mt-2"
                                color="light"
                                size="sm"
                                onClick={handleAddTodo}
                                    >
                                <i className="ri-add-line" style={{ fontSize: '16px' }}/>
                            </Btn>
                        </div>

                        {todos.map((todo, index) => (
                            <div key={index} className='d-flex align-items-center todolist'>
                                <span className='mr-2'>{todo.obsNum}</span>
                                <TextField
                                    size='small'
                                    label='Observação'
                                    fullWidth
                                    value={todo.observacao}
                                    onChange={(e) => handleTodoChange(index, 'observacao', e.target.value)}
                                />
                                <TextField
                                    size='small'
                                    label='Página'
                                    sx={{width: '100px'}}
                                    value={todo.pagina}
                                    onChange={(e) => handleTodoChange(index, 'pagina', e.target.value)}
                                />
                                <Btn
                                    title="Deletar Observação"
                                    color="danger"
                                    size="sm"
                                    onClick={() => handleDeleteTodo(index)}
                                    className="ml-2"
                                >
                                    <i className="ri-delete-bin-line" style={{ fontSize: '16px' }}/>
                                </Btn>
                            </div>
                        ))}
                    </div>
                </div>
            </DialogContent>
            <DialogActions>
                {isStatusLoading &&(
                    <Button
                        autoFocus
                        margin="dense"
                        id="entregaRevInterna"
                        name="entrega_rev_interna"
                        label="Entrega a Revisao Interna"
                        type="submit"
                        variant="outlined"
                        disabled
                        endIcon={<Spinner/>}
                    >Aguarde</Button>
                )}
                {!isStatusLoading && (
                    <>
                        <Button
                            autoFocus
                            className='text-success'
                            margin="dense"
                            id="aprova"
                            name="aprova_produto"
                            label="Aprovar o produto"
                            type="submit"
                            variant="standard"
                            onClick={aprovaCompliance}
                        >Aprovar</Button>
                        <Button
                            autoFocus
                            className='text-danger'
                            margin="dense"
                            id="reprova"
                            name="reprova_produto"
                            label="Reprovar o produto"
                            type="submit"
                            variant="standard"
                            onClick={reprovaCompliance}
                        >Reprovar</Button>
                    </>
                )}
                <Button onClick={handleClose}>Cancelar</Button>
            </DialogActions>
            </Dialog>
        </>
    )
    }

ModalFormRevInterna.propTypes = {
dataPrevista: PropTypes.string,
tecResp: PropTypes.string,
};

export default ModalFormRevInterna;
